import { jsx } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { brandLogo, newJobCardDensityMobileBrandLogo, fitParentContainer } from "./LazyLoadedImg.css.mjs";
const LazyLoadedImg = ({
  src,
  useNewJobCardDensityMobileStyle,
  id
}) => src === void 0 ? null : /* @__PURE__ */ jsx(
  Box,
  {
    className: !useNewJobCardDensityMobileStyle ? brandLogo : newJobCardDensityMobileBrandLogo,
    data: {
      testid: id ?? "company-logo-container",
      automation: "company-logo-container"
    },
    children: /* @__PURE__ */ jsx(
      Box,
      {
        display: "flex",
        height: "full",
        data: {
          automation: "company-logo"
        },
        children: /* @__PURE__ */ jsx("img", { className: fitParentContainer, src, loading: "lazy" })
      }
    )
  }
);
export {
  LazyLoadedImg
};
